import { addDays, formatLongDate, isSameDay } from '@/utils/date';

export const buildAbsenceDateLabel = (
  iso: string,
  todayLabel: string,
  yesterdayLabel: string,
): string => {
  const date = new Date(iso);
  const long = formatLongDate(iso);
  const today = new Date();

  if (isSameDay(date, today)) {
    return `${todayLabel}, ${long}`;
  }

  const yesterday = addDays(today, -1);

  if (isSameDay(date, yesterday)) {
    return `${yesterdayLabel}, ${long}`;
  }

  return long;
};
